import { Component } from '@angular/core';
import { NavController, ToastController } from 'ionic-angular';

import { ContratoProvider } from './../../../providers/contrato/contrato.provider';
import { AnonymizeProvider } from './../../../providers/anonymize/anonymize.provider';
import { PermissionService } from './../../../providers/permission-service';
import { Contrato } from '../../../domain/contrato';
import { Evento } from '../../../domain/evento';

import { ContratoFormPage } from './../contrato-form/contrato-form';
import { ParticipacaoPage } from '../../participacao/participacao';

@Component({
  selector: 'contrato-search',
  templateUrl: 'contrato-search.html'
})
export class ContratoSearchPage {

    searchTerm: string = '';
    contratos: any;
    searching: any = false;
    searchFocused: boolean = false;
    buttons: any;
    public evento_aberto: Evento;
    public contratoFormPage = ContratoFormPage;

    private searchTimeout: any;

    constructor(public navCtrl: NavController,
                public contratoProvider: ContratoProvider,
                public toastCtrl: ToastController,
                public anonymizeProvider: AnonymizeProvider,
                private permissionService: PermissionService) {

        this.getEventoAberto();
        this.acoes();
    }

    acoes() {
        this.buttons = [
            {nome:'Editar', icon:'create', color:'danger', pageDestino:ContratoFormPage},
            {nome:'Reciclar', icon:'ios-git-compare', color:'avsi', pageDestino:ParticipacaoPage}
        ];
    }

    onSearchInput(){
        clearTimeout(this.searchTimeout);
        this.searching = true;
        this.searchTimeout = setTimeout(() => this.setFilteredItems(), 500);
    }

    clearSearch() {
        this.searchTerm = '';
        this.contratos = false;
    }

    canAddContratos(): boolean {
        return this.permissionService.hasNavigationPermission('contratos', 'cadastrar');
    }

    // ECOENEL-258: cadastro de contrato em campo só é ofertado quando o evento
    // aberto possui a flag cadastro_em_campo habilitada (ex.: Recicla Carapicuíba).
    podeCadastrarEmCampo(): boolean {
        return !!(this.evento_aberto && this.evento_aberto.cadastro_em_campo);
    }

    cadastrarEmCampo() {
        if (!this.podeCadastrarEmCampo()) {
            return;
        }

        // ECOENEL-258: não passar `id` aqui. Com `id: null` o contrato-form
        // ficava preso entre as duas condições *ngIf do campo Nome
        // (null !== undefined e null > 0 são ambas falsas), o input não era
        // renderizado e, por ser required, travava o Salvar. Omitir o id
        // deixa contratoId === undefined, replicando o fluxo de "Novo" comum.
        this.navCtrl.push(ContratoFormPage, {
            numero: this.searchTerm ? this.searchTerm.toUpperCase() : null
        });
    }

    goToPage(button:any, id){
      if (this.evento_aberto === undefined) {

        let toast = this.toastCtrl.create({ duration: 1500 });
        toast.setMessage('Selecione um evento antes de continuar!');
        toast.present();
        return;
      }

        this.navCtrl.push(button.pageDestino, {
            'id':id
        });
    }

    setFilteredItems() {
        if(this.searchTerm != ''){
            let busca = this.contratoProvider.search(this.searchTerm.toUpperCase());
            busca.subscribe(result => {
                this.contratos = result.json().contratos as Contrato[];
                this.searching = false;
            })
        }else{
            this.contratos = false;
            this.searching = false;
        }

    }

    private getEventoAberto():any{
        if(localStorage.getItem('evento_aberto')){
            this.evento_aberto = JSON.parse(localStorage.getItem('evento_aberto'));
            return true;
        }else{
            let toast = this.toastCtrl.create({ duration: 1500 });
            let self = this;
            toast.setMessage('Selecione um evento antes de continuar!');
            toast.present();
            toast.onDidDismiss(() => {
                self.navCtrl.setRoot('HomePage');
            });
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/contratos/contrato-search/contrato-search.ts